var _style, _g, _path, _path2, _path3, _g2, _defs, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _g4, _g5, _g6, _g7, _g8, _path10, _path11, _path12, _path13, _path14, _g9, _path15, _path16, _g10, _g11, _g12, _path17, _path18, _path19, _defs2, _g13, _g14, _g15, _g16, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCryptocurrencExchanges(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 650 597",
    style: {
      enableBackground: "new 0 0 650 597"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#222325;}\r\n\t.st1{fill:#393A3D;}\r\n\t.st2{opacity:0.5;fill:url(#SVGID_1_);enable-background:new    ;}\r\n\t.st3{fill:#00C39A;}\r\n\t.st4{fill:#42E8E0;}\r\n\t.st5{opacity:0.3;fill:#0F054C;enable-background:new    ;}\r\n\t.st6{fill:#FFFFFF;}\r\n\t.st7{opacity:0.51;fill:#00C39A;enable-background:new    ;}\r\n\t.st8{opacity:0.8;fill:url(#SVGID_00000076570486836967664250000005468449979731795591_);enable-background:new    ;}\r\n\t.st9{opacity:0.1;}\r\n\t.st10{opacity:0.5;fill:url(#SVGID_00000151527379736243217040000007896721641800046770_);enable-background:new    ;}\r\n\t.st11{clip-path:url(#SVGID_00000067932138452268467590000005644044789868930718_);}\r\n\t.st12{fill:#9FFFF8;}\r\n\t.st13{opacity:0.4;fill:#24126A;enable-background:new    ;}\r\n\t.st14{opacity:0.3;fill:#00C39A;enable-background:new    ;}\r\n\t.st15{opacity:0.3;}\r\n\t.st16{opacity:0.4;fill:#42E8E0;enable-background:new    ;}\r\n\t.st17{fill:url(#SVGID_00000026882075208261294990000014748530996480886206_);}\r\n\t.st18{fill:url(#SVGID_00000085221694317549459270000009404277113517236381_);}\r\n\t.st19{fill:url(#SVGID_00000096022550989377569150000016873637584844321155_);}\r\n\t.st20{opacity:0.2;fill:#42E8E0;enable-background:new    ;}\r\n\t.st21{clip-path:url(#SVGID_00000015349445281965709880000003789545800008225684_);}\r\n\t.st22{fill:url(#SVGID_00000080168101937556122020000016969466257996948143_);}\r\n\t.st23{fill:#F7A600;}\r\n\t.st24{fill:url(#SVGID_00000077321528681964557610000004235228806522352802_);}\r\n\t.st25{fill:#FFBA00;}\r\n\t.st26{fill:#6C8095;}\r\n\t.st27{fill:url(#SVGID_00000180367823698619024130000002833667968406979733_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311,127.8l201.4,132c83.9,55,107.8,167.9,53.2,252.1l0,0c-54.6,84.1-167,107.8-250.9,52.8l-201.5-132 C29.3,377.7,5.4,264.8,60,180.6l0,0C114.6,96.3,227,72.6,311,127.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.930363e-02 -0.9988 0.9988 4.930363e-02 -190.2454 906.4515)",
    className: "st1",
    cx: 381,
    cy: 553.2,
    rx: 3.2,
    ry: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.2,530c1.8,0.1,3.1,1.5,3,3.3s-1.5,3.1-3.3,3c-1.8-0.1-3.1-1.5-3-3.3C379,531.1,380.6,529.9,382.2,530z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.930363e-02 -0.9988 0.9988 4.930363e-02 -148.3449 870.4297)",
    className: "st1",
    cx: 383.1,
    cy: 513.1,
    rx: 3.2,
    ry: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M384.2,490c1.8,0.1,3.1,1.5,3,3.3s-1.5,3.1-3.3,3c-1.8-0.1-3.1-1.5-3-3.3C381,491.1,382.6,489.9,384.2,490z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.930363e-02 -0.9988 0.9988 4.930363e-02 -106.5344 834.3033)",
    className: "st1",
    cx: 385,
    cy: 473.1,
    rx: 3.2,
    ry: 3.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.2,550.7c1.8,0.1,3.1,1.5,3,3.3s-1.5,3.1-3.3,3s-3.1-1.5-3-3.3C393,551.9,394.5,550.6,396.2,550.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.2,530.7c1.8,0.1,3.1,1.5,3,3.3c-0.1,1.8-1.5,3.1-3.3,3c-1.9-0.1-3.1-1.5-3-3.3 C394,531.9,395.6,530.7,397.2,530.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M398.2,510.7c1.8,0.1,3.1,1.5,3,3.3s-1.5,3.1-3.3,3c-1.8-0.1-3.1-1.5-3-3.3 C395,511.9,396.6,510.6,398.2,510.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.2,490.7c1.8,0.1,3.1,1.5,3,3.3s-1.5,3.1-3.3,3c-1.8-0.1-3.1-1.5-3-3.3 C395.9,491.9,397.5,490.6,399.2,490.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.1,470.7c1.8,0.1,3.1,1.5,3,3.3c-0.1,1.8-1.5,3.1-3.3,3c-1.8-0.1-3.1-1.5-3-3.3 C396.9,471.9,398.5,470.6,400.1,470.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.930363e-02 -0.9988 0.9988 4.930363e-02 -163.1789 937.7381)",
    className: "st1",
    cx: 411,
    cy: 554.6,
    rx: 3.2,
    ry: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.2,531.4c1.8,0.1,3.1,1.5,3,3.3s-1.5,3.1-3.3,3c-1.8-0.1-3.1-1.5-3-3.3S410.3,531.3,412.2,531.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.930363e-02 -0.9988 0.9988 4.930363e-02 -121.4729 901.7018)",
    className: "st1",
    cx: 412.9,
    cy: 514.7,
    rx: 3.2,
    ry: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.1,491.4c1.8,0.1,3.1,1.5,3,3.3c-0.1,1.8-1.5,3.1-3.3,3s-3.1-1.5-3-3.3 C411,492.7,412.4,491.3,414.1,491.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.930363e-02 -0.9988 0.9988 4.930363e-02 -79.5723 865.6799)",
    className: "st1",
    cx: 414.9,
    cy: 474.6,
    rx: 3.2,
    ry: 3.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.930363e-02 -0.9988 0.9988 4.930363e-02 -149.7428 953.3741)",
    className: "st1",
    cx: 425.9,
    cy: 555.3,
    rx: 3.2,
    ry: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427.1,532.2c1.8,0.1,3.1,1.5,3,3.3s-1.5,3.1-3.3,3c-1.8-0.1-3.1-1.5-3-3.3 C423.9,533.3,425.3,532.1,427.1,532.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.930363e-02 -0.9988 0.9988 4.930363e-02 -107.8423 917.3524)",
    className: "st1",
    cx: 428,
    cy: 515.3,
    rx: 3.2,
    ry: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.1,492.2c1.8,0.1,3.1,1.5,3,3.3c-0.1,1.8-1.5,3.1-3.3,3c-1.9-0.1-3.1-1.5-3-3.3 C425.9,493.4,427.3,492.1,429.1,492.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.930363e-02 -0.9988 0.9988 4.930363e-02 -66.1363 881.3161)",
    className: "st1",
    cx: 429.9,
    cy: 475.4,
    rx: 3.2,
    ry: 3.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.1,552.9c1.8,0.1,3.1,1.5,3,3.3c-0.1,1.8-1.5,3.1-3.3,3c-1.8-0.1-3.1-1.5-3-3.3 C437.8,554.1,439.3,552.8,441.1,552.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M442,532.9c1.8,0.1,3.1,1.5,3,3.3c-0.1,1.8-1.5,3.1-3.3,3c-1.8-0.1-3.1-1.5-3-3.3 C438.9,534.1,440.3,532.8,442,532.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.1,513c1.8,0.1,3.1,1.5,3,3.3s-1.5,3.1-3.3,3c-1.8-0.1-3.1-1.5-3-3.3S441.2,512.9,443.1,513z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M444.1,492.9c1.8,0.1,3.1,1.5,3,3.3c-0.1,1.8-1.5,3.1-3.3,3c-1.9-0.1-3.1-1.5-3-3.3 C440.8,494.1,442.3,492.9,444.1,492.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M445,472.9c1.8,0.1,3.1,1.5,3,3.3c-0.1,1.8-1.5,3.1-3.3,3c-1.8-0.1-3.1-1.5-3-3.3 C441.8,474.2,443.3,472.9,445,472.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.930363e-02 -0.9988 0.9988 4.930363e-02 -122.7807 984.7508)",
    className: "st1",
    cx: 455.9,
    cy: 556.9,
    rx: 3.2,
    ry: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M457.1,533.6c1.8,0.1,3.1,1.5,3,3.3c-0.1,1.8-1.5,3.1-3.3,3c-1.8-0.1-3.1-1.5-3-3.3S455.2,533.5,457.1,533.6 z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.930363e-02 -0.9988 0.9988 4.930363e-02 -80.9703 948.6244)",
    className: "st1",
    cx: 457.8,
    cy: 516.8,
    rx: 3.2,
    ry: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M459,493.7c1.8,0.1,3.1,1.5,3,3.3c-0.1,1.8-1.5,3.1-3.3,3c-1.8-0.1-3.1-1.5-3-3.3 C455.7,494.9,457.2,493.6,459,493.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.930363e-02 -0.9988 0.9988 4.930363e-02 -39.0698 912.6026)",
    className: "st1",
    cx: 459.8,
    cy: 476.8,
    rx: 3.2,
    ry: 3.1
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_\\u0428\\u0430\\u0440_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u0428\\u0430\\u0440_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.7,
    y1: 293.3,
    x2: 552.8,
    y2: 293.3,
    gradientTransform: "matrix(1 0 0 -1 0 598)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C39A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#393A3D"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.8,102h455v383.1c0,12.3-9.5,22.3-21.2,22.3H118.9c-11.7,0-21.2-10-21.2-22.3V102H97.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.4,67.4h419.7c9.7,0,17.6,8.3,17.6,18.6v16h-455V86C97.8,75.7,105.7,67.4,115.4,67.4z"
  })), /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M263.7,417.1c-3.3,0-6.4-0.7-8.8-2.1L140,345.2c-2.3-1.4-3.6-3.3-3.6-5.5c0-2.6,1.8-5.1,5-7.1l219.2-133.2 c6-3.6,15-4,20.2-0.9l114.9,69.9c2.3,1.4,3.6,3.3,3.6,5.5c0,2.6-1.8,5.1-5,7.1L275.1,414.1 C271.8,416.1,267.7,417.1,263.7,417.1L263.7,417.1z M255.2,414.6c5,3.1,13.9,2.7,19.7-0.9L494,280.5c3-1.8,4.8-4.3,4.8-6.6 c0-1.9-1.2-3.7-3.3-5L380.6,199c-5-3.1-13.9-2.7-19.7,0.9L141.7,333c-3,1.8-4.8,4.3-4.8,6.6c0,1.9,1.2,3.7,3.3,5L255.2,414.6 L255.2,414.6z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M499,241.6l-16.5,3l-101.8-61.9c-5.1-3.1-14-2.7-19.9,0.9L165.9,302l-29.2,5.3v10.9l0,0 c0,2,1.1,3.9,3.4,5.3L255,393.3c5.1,3.1,14,2.7,19.9-0.9l219.2-133.2c3.2-1.9,4.8-4.4,4.9-6.7l0,0L499,241.6L499,241.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M255,382.3l-114.9-69.9c-5.1-3.1-4.5-8.5,1.4-12.1l219.2-133.2c5.9-3.6,14.8-4,19.9-0.9l114.9,69.9 c5.1,3.1,4.5,8.5-1.4,12.1L275,381.5C269.1,385.1,260.1,385.4,255,382.3L255,382.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M494.1,248.2L275,381.5c-5.9,3.6-14.8,4-19.9,0.9l-114.9-69.9c-2.1-1.2-3.2-2.9-3.4-4.6 c-0.3,2.2,0.8,4.4,3.4,6L255,383.7c5.1,3.1,14,2.7,19.9-0.9l219.2-133.2c3.5-2.1,5.2-5,4.8-7.5 C498.6,244.3,497,246.5,494.1,248.2L494.1,248.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M255.3,379.6l-110.8-67.4c-4.9-3-4.3-8.3,1.4-11.7L361,169.8c5.7-3.5,14.3-3.8,19.3-0.8L491,236.3 c4.9,3,4.3,8.3-1.4,11.7l-215,130.8C268.8,382.3,260.2,382.6,255.3,379.6L255.3,379.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011017385462741569350000004563939617185665974_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.645,
    y1: 1659.5321,
    x2: 267.755,
    y2: 1526.9679,
    gradientTransform: "matrix(1 0 0 1 0 -1322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#42E8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#36B5BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#2C87A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#235F86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#1B3E71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#162560"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#121355"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#0F084E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0F054C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000011017385462741569350000004563939617185665974_)",
      enableBackground: "new"
    },
    d: " M263.6,379c-3.2,0-6.3-0.7-8.6-2.1l-110.8-67.4c-2.3-1.4-3.5-3.3-3.5-5.4c0-2.5,1.8-5.1,4.9-7l215.1-130.7 c5.8-3.5,14.6-3.9,19.6-0.8L491.2,233c2.3,1.4,3.5,3.3,3.5,5.4c0,2.5-1.8,5.1-4.9,7L274.7,376.1C271.6,378,267.5,379,263.6,379 L263.6,379z M255.4,376.3c4.8,2.9,13.3,2.6,18.9-0.8l215.1-130.7c2.9-1.8,4.5-4.1,4.5-6.3c0-1.8-1.1-3.5-3.2-4.8L380,166.3 c-4.8-2.9-13.3-2.6-18.9,0.8L146,297.8c-2.9,1.8-4.5,4.1-4.5,6.3c0,1.8,1.1,3.5,3.2,4.8L255.4,376.3L255.4,376.3z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000042711672133108232120000016495078648907402650_",
    cx: 532.9284,
    cy: 1717.8347,
    r: 405.14,
    gradientTransform: "matrix(0.7 0 0 0.737 -64.2 -991.146)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#42E8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#36B5BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#2C87A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#235F86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#1B3E71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#162560"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#121355"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#0F084E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0F054C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000042711672133108232120000016495078648907402650_)",
      enableBackground: "new"
    },
    d: " M255.3,376.6l-110.8-67.4c-4.9-3-4.3-8.3,1.4-11.7L361,166.8c5.7-3.5,14.3-3.8,19.3-0.8L491,233.3c4.9,3,4.3,8.3-1.4,11.7 l-215,130.8C268.8,379.2,260.2,379.6,255.3,376.6L255.3,376.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000135681481223962024000000016442539322518739612_",
    d: "M255.3,376.6l-110.8-67.4 c-4.9-3-4.3-8.3,1.4-11.7L361,166.8c5.7-3.5,14.3-3.8,19.3-0.8L491,233.3c4.9,3,4.3,8.3-1.4,11.7l-215,130.8 C268.8,379.2,260.2,379.6,255.3,376.6L255.3,376.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148663497856095712100000000524674248808880804_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000135681481223962024000000016442539322518739612_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000148663497856095712100000000524674248808880804_)"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M377.7,351.3c0-14.7-9.8-32.5-21.8-39.8c-6-3.7-11.5-4-15.5-1.6l0,0l-4.1,2.5l1.2,0.1 c-2.2,2.8-3.4,6.9-3.4,12.2c0,14.7,9.8,32.5,21.8,39.8c4.1,2.5,8,3.5,11.3,3l-0.1,1.2l4.2-2.6l0,0l0.2-0.1l0,0 C375.3,363.6,377.6,358.5,377.7,351.3L377.7,351.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8866 -0.4626 0.4626 0.8866 -117.6711 201.3205)",
    className: "st4",
    cx: 351.7,
    cy: 340.6,
    rx: 18,
    ry: 32.1
  }))))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M467.4,244.5c-1.7,1-4.4,1-6.1,0s-1.7-2.7,0-3.7s4.4-1,6.1,0S469.1,243.5,467.4,244.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M444,226.6l12,7.3c1.5,0.9,1.3,2.4-0.4,3.5l0,0c-1.7,1-4.2,1.1-5.7,0.3l-12-7.3c-1.5-0.9-1.3-2.4,0.4-3.5 l0,0C440,225.8,442.5,225.7,444,226.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M375.6,182.9l12,7.3c1.5,0.9,1.3,2.4-0.4,3.5l0,0c-1.7,1-4.2,1.1-5.7,0.3l-12-7.3 c-1.5-0.9-1.3-2.4,0.4-3.5l0,0C371.6,182.1,374.1,182,375.6,182.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M467.4,240c-1.7,1-4.4,1-6.1,0s-1.7-2.7,0-3.7s4.4-1,6.1,0S469.1,239,467.4,240z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M444,222.1l12,7.3c1.5,0.9,1.3,2.4-0.4,3.5l0,0c-1.7,1-4.2,1.1-5.7,0.3l-12-7.3c-1.5-0.9-1.3-2.4,0.4-3.5 l0,0C440,221.3,442.5,221.2,444,222.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M375.6,178.3l12,7.3c1.5,0.9,1.3,2.4-0.4,3.5l0,0c-1.7,1-4.2,1.1-5.7,0.3l-12-7.3 c-1.5-0.9-1.3-2.4,0.4-3.5l0,0C371.6,177.6,374.1,177.4,375.6,178.3z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M534.5,399.1v-5.9l-1.5-0.9c-0.4,2.8-3.5,4.6-6.1,5l-17.7,10.9l-7.7,2.9l-24.6-13.4l0.6-0.3 c-2.1-1-3.2-3.4-4.4-5.6l-1.7,1l-1,0.3v6l0,0c0,1.2,0.7,2.3,2.2,3.2l24.7,15c2.9,1.8,7.6,1.8,10.5,0l24.7-15 c1.4-0.9,2.1-2,2.2-3.1C534.5,399.2,534.5,399.2,534.5,399.1L534.5,399.1L534.5,399.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M526.9,397.3l-17.7,10.9l-6.7,2.6v8c1.9,0,3.8-0.4,5.2-1.3l24.7-15c1.4-0.9,2.1-2,2.2-3.1 c0-0.1,0-0.1,0-0.2l0,0v-5.9l-1.4-0.8H533C532.5,395.1,529.4,396.9,526.9,397.3L526.9,397.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M497.2,411.4l-24.7-15c-2.9-1.8-2.9-4.6,0-6.4l24.7-15c2.9-1.8,7.6-1.8,10.5,0l24.7,15 c2.9,1.8,2.9,4.6,0,6.4l-24.7,15C504.8,413.2,500.1,413.2,497.2,411.4L497.2,411.4z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M497.2,411.4l-24.7-15c-2.9-1.8-2.9-4.6,0-6.4l24.7-15c2.9-1.8,7.6-1.8,10.5,0l24.7,15 c2.9,1.8,2.9,4.6,0,6.4l-24.7,15C504.8,413.2,500.1,413.2,497.2,411.4L497.2,411.4z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M502.4,392.5c-1.7,0-3.4-0.4-4.7-1.2l-24.7-15c-1.3-0.8-2-1.8-2-3c0-1.1,0.7-2.2,2-3l24.7-15 c2.6-1.6,6.7-1.6,9.3,0l24.7,15c1.3,0.8,2,1.8,2,3c0,1.1-0.7,2.2-2,3l-24.7,15C505.8,392.1,504.1,392.5,502.4,392.5 L502.4,392.5z M502.4,354.6c-1.6,0-3.2,0.4-4.4,1.1l-24.7,15c-1.1,0.7-1.8,1.6-1.8,2.6s0.6,1.9,1.8,2.6l24.7,15 c2.4,1.5,6.4,1.5,8.9,0l24.7-15c1.1-0.7,1.8-1.6,1.8-2.6s-0.6-1.9-1.8-2.6l-24.7-15C505.7,355,504.1,354.6,502.4,354.6 L502.4,354.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M534.5,367.6v-8.9l-1.5-0.9c-0.4,2.8-3.5,4.6-6.1,5l-17.7,10.9l-7.7,2.9l-24.6-13.4l0.6-0.3 c-2.1-1-3.2-3.4-4.4-5.6l-1.7,1l-1,0.3v9.1l0,0c0,1.2,0.7,2.3,2.2,3.2l24.7,15c2.9,1.8,7.6,1.8,10.5,0l24.7-15 c1.4-0.9,2.1-2,2.2-3.1C534.5,367.6,534.5,367.6,534.5,367.6L534.5,367.6L534.5,367.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M534.5,359.6v-5.9l-1.5-0.9c-0.4,2.8-3.5,4.6-6.1,5l-17.7,10.9l-7.7,2.9l-24.6-13.4l0.6-0.3 c-2.1-1-3.2-3.4-4.4-5.6l-1.7,1l-1,0.3v6l0,0c0,1.2,0.7,2.3,2.2,3.2l24.7,15c2.9,1.8,7.6,1.8,10.5,0l24.7-15 c1.4-0.9,2.1-2,2.2-3.1C534.5,359.7,534.5,359.7,534.5,359.6L534.5,359.6L534.5,359.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M526.9,357.8l-17.7,10.9l-6.7,2.6v8c1.9,0,3.8-0.4,5.2-1.3l24.7-15c1.4-0.9,2.1-2,2.2-3.1 c0-0.1,0-0.1,0-0.2l0,0v-5.9l-1.4-0.8H533C532.5,355.7,529.4,357.5,526.9,357.8L526.9,357.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M497.2,371.9l-24.7-15c-2.9-1.8-2.9-4.6,0-6.4l24.7-15c2.9-1.8,7.6-1.8,10.5,0l24.7,15 c2.9,1.8,2.9,4.6,0,6.4l-24.7,15C504.8,373.7,500.1,373.7,497.2,371.9L497.2,371.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M532.4,356.9l-24.7,15c-2.9,1.8-7.6,1.8-10.5,0l-24.7-15c-1.3-0.8-2-1.8-2.1-2.8 c-0.2,1.3,0.5,2.6,2.1,3.6l24.7,15c2.9,1.8,7.6,1.8,10.5,0l24.7-15c1.6-1,2.3-2.3,2.1-3.6 C534.4,355.2,533.7,356.2,532.4,356.9L532.4,356.9z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M424.6,434.1v-5.9l-1.5-0.9c-0.4,2.8-3.5,4.6-6.1,5l-17.7,10.9l-7.7,2.9L367,432.7l0.6-0.3 c-2.1-1-3.2-3.4-4.4-5.6l-1.7,1l-1,0.3v6l0,0c0,1.2,0.7,2.3,2.2,3.2l24.7,15c2.9,1.8,7.6,1.8,10.5,0l24.7-15 c1.4-0.9,2.1-2,2.2-3.1C424.6,434.2,424.6,434.2,424.6,434.1L424.6,434.1L424.6,434.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M416.9,432.3l-17.7,10.9l-6.7,2.6v8c1.9,0,3.8-0.4,5.2-1.3l24.7-15c1.4-0.9,2.1-2,2.2-3.1 c0-0.1,0-0.1,0-0.2l0,0v-5.9l-1.4-0.8h-0.1C422.6,430.2,419.5,432,416.9,432.3L416.9,432.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M387.3,446.4l-24.7-15c-2.9-1.8-2.9-4.6,0-6.4l24.7-15c2.9-1.8,7.6-1.8,10.5,0l24.7,15 c2.9,1.8,2.9,4.6,0,6.4l-24.7,15C394.9,448.2,390.2,448.2,387.3,446.4z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M387.3,446.4l-24.7-15c-2.9-1.8-2.9-4.6,0-6.4l24.7-15c2.9-1.8,7.6-1.8,10.5,0l24.7,15 c2.9,1.8,2.9,4.6,0,6.4l-24.7,15C394.9,448.2,390.2,448.2,387.3,446.4z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M392.5,424.6c-1.7,0-3.4-0.4-4.7-1.2l-24.7-15c-1.3-0.8-2-1.8-2-3s0.7-2.2,2-3l24.7-15 c2.6-1.6,6.7-1.6,9.3,0l24.7,15c1.3,0.8,2,1.8,2,3s-0.7,2.2-2,3l-24.7,15C395.9,424.2,394.2,424.6,392.5,424.6L392.5,424.6z  M388.1,423.1c2.4,1.5,6.4,1.5,8.9,0l24.7-15c1.1-0.7,1.8-1.6,1.8-2.6s-0.6-1.9-1.8-2.6l-24.7-15c-2.4-1.5-6.4-1.5-8.9,0 l-24.7,15c-1.1,0.7-1.8,1.6-1.8,2.6s0.6,1.9,1.8,2.6L388.1,423.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M424.6,399.7v-8.9l-1.5-0.9c-0.4,2.8-3.5,4.6-6.1,5l-17.7,10.9l-7.7,2.9L367,395.3l0.6-0.3 c-2.1-1-3.2-3.4-4.4-5.6l-1.7,1l-1,0.3v9.1l0,0c0,1.2,0.7,2.3,2.2,3.2l24.7,15c2.9,1.8,7.6,1.8,10.5,0l24.7-15 c1.4-0.9,2.1-2,2.2-3.1C424.6,399.8,424.6,399.8,424.6,399.7L424.6,399.7L424.6,399.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M424.6,391.8v-5.9l-1.5-0.9c-0.4,2.8-3.5,4.6-6.1,5l-17.7,10.9l-7.7,2.9L367,390.4l0.6-0.3 c-2.1-1-3.2-3.4-4.4-5.6l-1.7,1l-1,0.3v6l0,0c0,1.2,0.7,2.3,2.2,3.2l24.7,15c2.9,1.8,7.6,1.8,10.5,0l24.7-15 c1.4-0.9,2.1-2,2.2-3.1C424.6,391.9,424.6,391.8,424.6,391.8L424.6,391.8L424.6,391.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M416.9,390l-17.7,10.9l-6.7,2.6v8c1.9,0,3.8-0.4,5.2-1.3l24.7-15c1.4-0.9,2.1-2,2.2-3.1 c0-0.1,0-0.1,0-0.2l0,0V386l-1.4-0.8h-0.1C422.6,387.8,419.5,389.6,416.9,390L416.9,390z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M387.3,404.1l-24.7-15c-2.9-1.8-2.9-4.6,0-6.4l24.7-15c2.9-1.8,7.6-1.8,10.5,0l24.7,15 c2.9,1.8,2.9,4.6,0,6.4l-24.7,15C394.9,405.9,390.2,405.9,387.3,404.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M392.5,401.4c-1.5,0-3-0.4-4.2-1.1L369,388.6c-1.2-0.7-1.8-1.7-1.8-2.7s0.6-2,1.8-2.7l19.3-11.7 c2.3-1.4,6.1-1.4,8.4,0l19.3,11.7c1.2,0.7,1.8,1.7,1.8,2.7s-0.6,2-1.8,2.7l-19.3,11.7C395.6,401,394.1,401.4,392.5,401.4 L392.5,401.4z M388.5,399.9c2.2,1.3,5.8,1.3,8,0l19.3-11.7c1-0.6,1.6-1.4,1.6-2.3s-0.6-1.7-1.6-2.3l-19.3-11.7 c-2.2-1.3-5.8-1.3-8,0l-19.3,11.7c-1,0.6-1.6,1.4-1.6,2.3s0.6,1.7,1.6,2.3L388.5,399.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M422.5,389.1l-24.7,15c-2.9,1.8-7.6,1.8-10.5,0l-24.7-15c-1.3-0.8-2-1.8-2.1-2.8 c-0.2,1.3,0.5,2.6,2.1,3.6l24.7,15c2.9,1.8,7.6,1.8,10.5,0l24.7-15c1.6-1,2.3-2.3,2.1-3.6 C424.5,387.3,423.8,388.3,422.5,389.1L422.5,389.1z"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M213.5,225.2v-5.9l-1.5-0.9c-0.4,2.8-3.5,4.6-6.1,5l-17.7,10.9l-7.7,2.9l-24.6-13.4l0.6-0.3 c-2.1-1-3.2-3.4-4.4-5.6l-1.7,1l-1,0.3v6l0,0c0,1.2,0.7,2.3,2.2,3.2l24.7,15c2.9,1.8,7.6,1.8,10.5,0l24.7-15 c1.4-0.9,2.1-2,2.2-3.1C213.5,225.3,213.5,225.3,213.5,225.2L213.5,225.2L213.5,225.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M205.8,223.4l-17.7,10.9l-6.7,2.6v8c1.9,0,3.8-0.4,5.2-1.3l24.7-15c1.4-0.9,2.1-2,2.2-3.1 c0-0.1,0-0.1,0-0.2l0,0v-5.9l-1.4-0.8H212C211.4,221.2,208.4,223,205.8,223.4L205.8,223.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M176.1,237.5l-24.7-15c-2.9-1.8-2.9-4.6,0-6.4l24.7-15c2.9-1.8,7.6-1.8,10.5,0l24.7,15 c2.9,1.8,2.9,4.6,0,6.4l-24.7,15C183.7,239.3,179,239.3,176.1,237.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M176.1,237.5l-24.7-15c-2.9-1.8-2.9-4.6,0-6.4l24.7-15c2.9-1.8,7.6-1.8,10.5,0l24.7,15 c2.9,1.8,2.9,4.6,0,6.4l-24.7,15C183.7,239.3,179,239.3,176.1,237.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M181.4,219.5c-1.7,0-3.4-0.4-4.7-1.2l-24.7-15c-1.3-0.8-2-1.8-2-3c0-1.1,0.7-2.2,2-3l24.7-15 c2.6-1.6,6.7-1.6,9.3,0l24.7,15c1.3,0.8,2,1.8,2,3c0,1.1-0.7,2.2-2,3l-24.7,15C184.8,219.1,183.1,219.5,181.4,219.5 L181.4,219.5z M181.4,181.7c-1.6,0-3.2,0.4-4.4,1.1l-24.7,15c-1.1,0.7-1.8,1.6-1.8,2.6s0.6,1.9,1.8,2.6l24.7,15 c2.4,1.5,6.4,1.5,8.9,0l24.7-15c1.1-0.7,1.8-1.6,1.8-2.6s-0.6-1.9-1.8-2.6l-24.7-15C184.6,182.1,183,181.7,181.4,181.7z"
  })), /*#__PURE__*/React.createElement("g", null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M213.5,194.6v-8.9l-1.5-0.9c-0.4,2.8-3.5,4.6-6.1,5l-17.7,10.9l-7.7,2.9l-24.6-13.4l0.6-0.3 c-2.1-1-3.2-3.4-4.4-5.6l-1.7,1l-1,0.3v9.1l0,0c0,1.2,0.7,2.3,2.2,3.2l24.7,15c2.9,1.8,7.6,1.8,10.5,0l24.7-15 c1.4-0.9,2.1-2,2.2-3.1C213.5,194.7,213.5,194.7,213.5,194.6L213.5,194.6L213.5,194.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M213.5,186.7v-5.9l-1.5-0.9c-0.4,2.8-3.5,4.6-6.1,5l-17.7,10.9l-7.7,2.9l-24.6-13.4l0.6-0.3 c-2.1-1-3.2-3.4-4.4-5.6l-1.7,1l-1,0.3v6l0,0c0,1.2,0.7,2.3,2.2,3.2l24.7,15c2.9,1.8,7.6,1.8,10.5,0l24.7-15 c1.4-0.9,2.1-2,2.2-3.1C213.5,186.8,213.5,186.8,213.5,186.7L213.5,186.7L213.5,186.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M205.8,184.9l-17.7,10.9l-6.7,2.6v8c1.9,0,3.8-0.4,5.2-1.3l24.7-15c1.4-0.9,2.1-2,2.2-3.1 c0-0.1,0-0.1,0-0.2l0,0v-5.9l-1.4-0.8H212C211.4,182.7,208.4,184.5,205.8,184.9L205.8,184.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039128269969397261550000013298011775416297907_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.6914,
    y1: 1489.7369,
    x2: 204.1784,
    y2: 1515.9988,
    gradientTransform: "matrix(1 0 0 1 0 -1322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#5761D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#7A81E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#979BF0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#ABAEF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#B7BAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BCBEFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039128269969397261550000013298011775416297907_)"
    },
    d: "M156.3,185l23.4-14.2 c0.9-0.6,2.4-0.6,3.4,0l23,14l-0.3,0.2c2.6-0.4,5.7-2.2,6.1-5l-25.8-15.1l-7.5-2.1l-6.1,3.8l-20.6,12.9 C153.1,181.6,154.2,184,156.3,185L156.3,185z"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M181.4,163.5l-2.8-0.8l-6.1,3.8l-20.6,12.9c1.1,2.2,2.3,4.5,4.4,5.6l23.4-14.2 c0.5-0.3,1.1-0.4,1.7-0.4L181.4,163.5L181.4,163.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088855911241185028370000008351235307377091984_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.225,
    y1: 1502.8,
    x2: 213.475,
    y2: 1502.8,
    gradientTransform: "matrix(1 0 0 1 0 -1322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E9E9FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#D2D2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#C4C3F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0BFF6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088855911241185028370000008351235307377091984_)"
    },
    d: "M176.1,199l-24.7-15 c-2.9-1.8-2.9-4.6,0-6.4l24.7-15c2.9-1.8,7.6-1.8,10.5,0l24.7,15c2.9,1.8,2.9,4.6,0,6.4l-24.7,15 C183.7,200.8,179,200.8,176.1,199z M183.1,164.8c-0.9-0.6-2.4-0.6-3.4,0l-24.7,15c-0.9,0.6-0.9,1.5,0,2l24.7,15 c0.9,0.6,2.4,0.6,3.4,0l24.7-15c0.9-0.6,0.9-1.5,0-2L183.1,164.8z"
  }), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.8,179.8l-24.7-15c-0.9-0.6-2.4-0.6-3.4,0l-24.7,15c-0.6,0.4-0.8,0.9-0.6,1.4 c0.1-0.2,0.3-0.5,0.6-0.7l24.7-15c0.9-0.6,2.4-0.6,3.4,0l24.7,15c0.3,0.2,0.5,0.4,0.6,0.7 C208.6,180.7,208.4,180.2,207.8,179.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.3,184l-24.7,15c-2.9,1.8-7.6,1.8-10.5,0l-24.7-15c-1.3-0.8-2-1.8-2.1-2.8 c-0.2,1.3,0.5,2.6,2.1,3.6l24.7,15c2.9,1.8,7.6,1.8,10.5,0l24.7-15c1.6-1,2.3-2.3,2.1-3.6 C213.3,182.2,212.6,183.2,211.3,184z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M176.8,198.6l-24.7-15c-2.5-1.5-2.5-4,0-5.5l24.7-15c2.5-1.5,6.6-1.5,9.1,0l24.7,15 c2.5,1.5,2.5,4,0,5.5l-24.7,15C183.4,200.1,179.3,200.1,176.8,198.6z M183.8,164.4c-1.3-0.8-3.4-0.8-4.8,0l-24.7,15 c-1.3,0.8-1.3,2.1,0,2.9l24.7,15c1.3,0.8,3.4,0.8,4.8,0l24.7-15c1.3-0.8,1.3-2.1,0-2.9L183.8,164.4z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M183.1,164.8c-0.9-0.6-2.4-0.6-3.4,0l-24.7,15c-0.9,0.6-0.9,1.5,0,2l24.7,15c0.9,0.6,2.4,0.6,3.4,0 l24.7-15c0.9-0.6,0.9-1.5,0-2L183.1,164.8z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034812642941251883280000008917720051031354269_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.35,
    y1: 1519.275,
    x2: 181.35,
    y2: 1424,
    gradientTransform: "matrix(1 0 0 1 0 -1322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C39A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.87
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.61
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.39
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034812642941251883280000008917720051031354269_)"
    },
    d: "M208.4,182.9V102h-54.1v80.9 c0,0.3,0.2,0.7,0.7,0.9l24.7,13.1c0.9,0.5,2.4,0.5,3.4,0l24.7-13.1C208.2,183.6,208.4,183.2,208.4,182.9L208.4,182.9z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M377.7,254.6c0-14.7-9.8-32.5-21.8-39.8c-6-3.7-11.5-4-15.5-1.6l0,0l-4.1,2.5l1.2,0.1 c-2.2,2.8-3.4,6.9-3.4,12.2c0,14.7,9.8,32.5,21.8,39.8c4.1,2.5,8,3.5,11.3,3l-0.1,1.2l4.2-2.6l0,0l0.2-0.1l0,0 C375.3,266.9,377.6,261.9,377.7,254.6L377.7,254.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8866 -0.4626 0.4626 0.8866 -72.9759 190.3793)",
    className: "st4",
    cx: 351.7,
    cy: 244,
    rx: 18,
    ry: 32.1
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M326.7,191.3c8.1-11.9,9.9-32.4,4.2-45.7c-2.9-6.7-7.2-10.3-11.7-10.7l0,0l-4.8-0.5l0.9,0.8 c-3.3,1-6.6,3.5-9.5,7.8c-8.1,11.9-9.9,32.4-4.2,45.7c2,4.6,4.6,7.7,7.5,9.4l-0.7,0.9l4.8,0.5c0,0,0,0,0.1,0h0.2l0,0 C318,199.9,322.7,197.2,326.7,191.3L326.7,191.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(8.668974e-02 -0.9962 0.9962 8.668974e-02 118.3076 462.4955)",
    className: "st4",
    cx: 311.4,
    cy: 166.7,
    rx: 32.5,
    ry: 17.8
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M334,287.8c0-14.7-9.8-32.5-21.8-39.8c-6-3.7-11.5-4-15.5-1.6l0,0l-4.1,2.5l1.2,0.1 c-2.2,2.8-3.4,6.9-3.4,12.2c0,14.7,9.8,32.5,21.8,39.8c4.1,2.5,8,3.5,11.3,3l-0.1,1.2l4.2-2.6l0,0l0.2-0.1l0,0 C331.6,300.1,334,295,334,287.8L334,287.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8866 -0.4626 0.4626 0.8866 -93.2581 173.9166)",
    className: "st4",
    cx: 308,
    cy: 277.1,
    rx: 18,
    ry: 32.1
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M309.4,311.7c-15.1,0-30.1-3.5-41.6-10.5c-11.1-6.8-17.3-15.8-17.3-25.4s6.1-18.6,17.3-25.4 c22.9-13.9,60.2-13.9,83.2,0c11.1,6.8,17.3,15.8,17.3,25.4s-6.1,18.6-17.3,25.4l-0.1-0.2l0.1,0.2 C339.5,308.2,324.5,311.7,309.4,311.7L309.4,311.7z M309.4,240.4c-15,0-30,3.5-41.4,10.4c-11,6.7-17.1,15.6-17.1,25 s6.1,18.3,17.1,25c22.8,13.9,59.9,13.9,82.7,0l0,0c11-6.7,17.1-15.6,17.1-25s-6.1-18.3-17.1-25 C339.4,243.9,324.4,240.4,309.4,240.4L309.4,240.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M309.4,321.3c-19.1,0-38.2-4.4-52.8-13.3c-14.1-8.6-21.9-20-21.9-32.2s7.8-23.6,21.9-32.2 c29.1-17.7,76.4-17.7,105.5,0c14.1,8.6,21.9,20,21.9,32.2s-7.8,23.6-21.9,32.2C347.6,316.9,328.5,321.3,309.4,321.3 L309.4,321.3z M309.4,230.8c-19,0-38.1,4.4-52.5,13.2c-14,8.5-21.7,19.8-21.7,31.8s7.7,23.3,21.7,31.8 c29,17.6,76.1,17.6,105.1,0c14-8.5,21.7-19.8,21.7-31.8S376,252.5,362,244C347.5,235.2,328.5,230.8,309.4,230.8L309.4,230.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M309.4,304.1c-11.9,0-23.7-2.7-32.8-8.2c-8.8-5.3-13.6-12.5-13.6-20s4.8-14.7,13.6-20 c18.1-11,47.5-11,65.5,0c8.8,5.3,13.6,12.5,13.6,20s-4.8,14.7-13.6,20l-0.1-0.2l0.1,0.2C333.2,301.4,321.3,304.1,309.4,304.1z  M309.4,248c-11.8,0-23.6,2.7-32.5,8.2c-8.7,5.3-13.4,12.2-13.4,19.7s4.8,14.4,13.4,19.7c17.9,10.9,47.2,10.9,65.1,0 c8.7-5.3,13.4-12.2,13.4-19.7s-4.8-14.4-13.4-19.7C333,250.7,321.2,248,309.4,248z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000123443195454228550460000006988254581678380677_",
    points: "343.6,282 329.9,290.3 275.2,257.1  275.2,193.2 343.6,234.8  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038413056355522282090000008730100472960464037_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123443195454228550460000006988254581678380677_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000038413056355522282090000008730100472960464037_)"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M334,287.8c0-14.7-9.8-32.5-21.8-39.8c-6-3.7-11.5-4-15.5-1.6l0,0l-4.1,2.5l1.2,0.1 c-2.2,2.8-3.4,6.9-3.4,12.2c0,14.7,9.8,32.5,21.8,39.8c4.1,2.5,8,3.5,11.3,3l-0.1,1.2l4.2-2.6l0,0l0.2-0.1l0,0 C331.6,300.1,334,295,334,287.8L334,287.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8866 -0.4626 0.4626 0.8866 -93.2581 173.9166)",
    className: "st4",
    cx: 308,
    cy: 277.1,
    rx: 18,
    ry: 32.1
  })))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M250.8,351.2l-68.5-41.7c-2-1.2-2-4.3,0-5.5l10.5-6.4c3.5-2.1,7.8-2.1,11.3,0l68.5,41.7 c2,1.2,2,4.3,0,5.5l-10.5,6.4C258.6,353.3,254.3,353.3,250.8,351.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "216.5,308.6 205.5,301.9 207.7,300.6 218.7,307.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "247.4,327.9 244,325.8 246.2,324.5 249.6,326.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "222.8,312.5 219.5,310.5 221.7,309.2 225,311.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M256.5,342.9c-2,0-4-0.5-5.8-1.6l-68.5-41.7c-1-0.6-1.6-1.7-1.6-3s0.6-2.4,1.6-3l10.5-6.4 c3.6-2.2,8-2.2,11.6,0l68.5,41.7c1,0.6,1.6,1.7,1.6,3s-0.6,2.4-1.6,3l-10.5,6.4C260.4,342.3,258.5,342.9,256.5,342.9z  M198.4,286.1c-1.9,0-3.8,0.5-5.5,1.6l-10.5,6.4c-0.9,0.5-1.4,1.5-1.4,2.5s0.5,2,1.4,2.5l68.5,41.7c3.4,2.1,7.6,2.1,11.1,0 l10.5-6.4c0.9-0.5,1.4-1.5,1.4-2.5s-0.5-2-1.4-2.5L204,287.7C202.2,286.6,200.3,286.1,198.4,286.1L198.4,286.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027576384237412711810000005113441248384837805_",
    gradientUnits: "userSpaceOnUse",
    x1: 502.75,
    y1: 1694.175,
    x2: 502.75,
    y2: 1598.9,
    gradientTransform: "matrix(1 0 0 1 0 -1322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C39A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.87
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.61
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.39
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027576384237412711810000005113441248384837805_)"
    },
    d: "M529.8,357.8v-80.9h-54.1v80.9 c0,0.3,0.2,0.7,0.7,0.9l24.7,13.1c0.9,0.5,2.4,0.5,3.4,0l24.7-13.1C529.6,358.4,529.8,358.1,529.8,357.8L529.8,357.8z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M514,325.8v-13.4h2.6v13.4H514z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M484.3,329.8h-5.5v-13.4h5.3c2.6,0,4,1.5,4,3.8c0,1.5-1,2.4-1.6,2.8c0.8,0.4,1.8,1.2,1.8,3 C488.3,328.4,486.6,329.8,484.3,329.8L484.3,329.8z M483.8,318.7h-2.5v3.1h2.5c1.1,0,1.7-0.6,1.7-1.5 C485.5,319.3,484.9,318.7,483.8,318.7z M484,324.2h-2.7v3.3h2.7c1.2,0,1.7-0.8,1.7-1.7S485.2,324.2,484,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M496.1,324.3v5.5h-2.5v-5.5l-3.9-7.9h2.8l2.4,5.4l2.4-5.4h2.8L496.1,324.3L496.1,324.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M507.2,329.8h-5.5v-13.4h5.3c2.6,0,4,1.5,4,3.8c0,1.5-1,2.4-1.6,2.8c0.8,0.4,1.8,1.2,1.8,3 C511.3,328.4,509.6,329.8,507.2,329.8L507.2,329.8z M506.8,318.7h-2.5v3.1h2.5c1.1,0,1.7-0.6,1.7-1.5 C508.5,319.3,507.9,318.7,506.8,318.7z M507,324.2h-2.7v3.3h2.7c1.2,0,1.7-0.8,1.7-1.7S508.1,324.2,507,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M524.8,318.7v11.1h-2.6v-11.1h-3.4v-2.3h9.4v2.3H524.8L524.8,318.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174569720510403364140000006195831293891745208_",
    gradientUnits: "userSpaceOnUse",
    x1: 392.25,
    y1: 1724.575,
    x2: 392.25,
    y2: 1629.3,
    gradientTransform: "matrix(1 0 0 1 0 -1322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C39A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.87
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.61
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.39
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174569720510403364140000006195831293891745208_)"
    },
    d: "M419.3,388.2v-80.9h-54.1v80.9 c0,0.3,0.2,0.7,0.7,0.9l24.7,13.1c0.9,0.5,2.4,0.5,3.4,0l24.7-13.1C419,388.9,419.3,388.6,419.3,388.2L419.3,388.2z"
  }), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "388.6,343.6 392.6,339.4 396.8,343.7 392.7,348  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "392.7,334.4 399.6,341.6 403.4,337.6 392.5,326.1 381.5,337.6 385.4,341.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "399.6,346.6 392.5,354.1 385.4,346.6 381.6,350.7 392.6,362.2 403.4,350.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "375.3,344 379.1,340 383.1,344.2 379.3,348.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "401.9,344.2 406.1,339.7 410.2,344 406,348.4  "
  }))))))), /*#__PURE__*/React.createElement("g", null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M535.7,84.6c0,0.5-0.7,1-1.6,1c-0.9,0-1.6-0.4-1.6-1c0-0.5,0.7-1,1.6-1C534.9,83.7,535.6,84.1,535.7,84.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029764968482345881940000016500290106012851085_",
    gradientUnits: "userSpaceOnUse",
    x1: 522.9704,
    y1: 1400.7422,
    x2: 524.1608,
    y2: 1414.1339,
    gradientTransform: "matrix(1 0 0 1 0 -1322)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.1e-7,
    style: {
      stopColor: "#51D6B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#98E2B9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029764968482345881940000016500290106012851085_)"
    },
    d: "M525.1,84.7c0,0.5-0.7,1-1.6,1 c-0.9,0-1.6-0.4-1.6-1c0-0.5,0.7-1,1.6-1S525.1,84.1,525.1,84.7z"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M514.6,84.8c0,0.5-0.7,1-1.6,1c-0.9,0-1.6-0.4-1.6-1c0-0.5,0.7-1,1.6-1S514.6,84.3,514.6,84.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptocurrencExchanges);
export default __webpack_public_path__ + "static/media/cryptocurrenc-exchanges.fbdb8c74c257e3348f1cc68b2b6f9f5f.svg";
export { ForwardRef as ReactComponent };